import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const GET_PORTFOLIOS = 'GET_PORTFOLIOS';

const apiCall = createApiCall(GET_PORTFOLIOS, (params: {}) => ({
  endpoint: generateEndpoint({
    host: '/api/admin/portfolios',
    params,
  }),
  method: 'GET',
}));

export default apiCall;
